import { type QueryClient, queryOptions } from '@tanstack/react-query';

import { apiOnchainFetch } from '@/api';

export enum WalletSetupStatus {
  NotStarted = 'not_started',
  Incomplete = 'incomplete',
  Ready = 'ready',
}

export interface WalletAccessResponse {
  status: WalletSetupStatus;
  privyUserId: string | null;
  providerWalletId: string | null;
  address: string | null;
}

export const getWalletAccess = () => apiOnchainFetch<WalletAccessResponse>('/wallet/access');

export const walletAccessQueryOptions = (ownerId: string) =>
  queryOptions({ queryKey: ['wallet-access', ownerId], queryFn: getWalletAccess });

export const fetchLatestWalletAccess = (queryClient: QueryClient, ownerId: string) =>
  queryClient.fetchQuery({ ...walletAccessQueryOptions(ownerId), staleTime: 0 });
